module.exports = {"350505001":"山腰街道","350505100":"南埔镇","350505101":"界山镇","350505102":"后龙镇","350505103":"峰尾镇","350505105":"前黄镇","350505106":"涂岭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350505.json
// module id = 1104
// module chunks = 0